import {
  PLATFORM_RATING__A_PLUS,
  PLATFORM_RATING__A_TOP
} from '../../Definition';

/**
 * Determines if a candidate is considered "A" or "A+" rated for platform evaluation.
 *
 * @function evalCandidateARating
 * @param {Object} candidate - Candidate object.
 * @param {number} [index] - Index of the candidate in a list (optional).
 * @param {Object[]} [candidates] - Full candidates array (optional).
 * @returns {boolean} True if candidate's platformRating is A+ or A Top.
 *
 * @description
 * - Uses `candidate.platformRating` and compares it against
 *   predefined constants `PLATFORM_RATING__A_PLUS` and `PLATFORM_RATING__A_TOP`.
 * - Casts `platformRating` to number to ensure proper comparison.
 * - Intended to be used in filters or mapping functions over candidate lists.
 */
export default function evalCandidateARating(candidate, index, candidates) {

  // TODO: 
  // all engagements are in review stage and candidate has A or A+ : true
  // other stages : true
  return [
    PLATFORM_RATING__A_PLUS,
    PLATFORM_RATING__A_TOP
  ].includes(+candidate.platformRating);
}
